















































































































































































import Vue from 'vue'
import SeismicForm from '@/models/SeismicForm'
import Input from '@/components/ui/Input.vue'

export default Vue.extend({
  components: {
    Input
  },
  props: {
    form: { type: [SeismicForm, Object] } // FIXME: should be SeismicForm but ... Still TypeScript
  },
  beforeDestroy () {
    this.$emit('saveForm', this.form)
  }
})

